import React from 'react';
import { Stack, Typography } from '@mui/material';
import TwCommoditiesBuilder from '../TwCommoditiesBuilder/TwCommoditiesBuilder';
import { EntityType } from '../../../redux/Global.model';

interface TwCommoditiesWrapperProps {
  entity: EntityType;
  isImport?: boolean;
}

export const TwCommoditiesWrapper = ({ entity, isImport = false }: TwCommoditiesWrapperProps): JSX.Element => {

  return (
    <Stack flexDirection={'column'} sx={{ marginTop: '2rem' }}>
      <Typography component="h5" className="route-info__info-title">
        Commodities
      </Typography>
      <TwCommoditiesBuilder title="Commodities" isImport={isImport} entity={entity} />
    </Stack>
  );
};

export default TwCommoditiesWrapper;
